module.exports = __webpack_public_path__ + "static/img/noDataTwo.d40adcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/noDataTwo.png
// module id = OYCR
// module chunks = 44